import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { ASSET_TYPE } from '@src/components/scene/react-three-components/sceneAsset';

export function AddIframe({ callBack, items }) {
  const [url, setURL] = useState<string>('');

  const onChangeStreamURL = (e) => {
    const inputValue = e.target.value;
    setURL(inputValue);
  };

  const handleAddStream = () => {
    if (url && url.trim() !== '') {
      callBack({
        type: ASSET_TYPE.PRIMITIVE_TEXTURE.STREAM,
        name: items[0].name,
        metadata: {
          type: 'iframe',
          url: url,
        },
      });
    }
  };

  return (
    <>
      <p>Iframe URL</p>
      <Input
        onChange={onChangeStreamURL}
        value={url}
        placeholder='Enter iframe URL'
      />

      <Button
        type='primary'
        style={{
          minHeight: 32,
          marginTop: 10,
        }}
        onClick={handleAddStream}
        disabled={!url || url.trim() === ''}
      >
        Add Iframe
      </Button>
    </>
  );
}
